import { Controller } from '@hotwired/stimulus'
import Debug from 'debug';

export const name = 'lib--slideover';
const debug = Debug(`app:${name}`);


export class SlideoverController extends Controller {
    static targets = ["dialog"]
    static values = {
        open: Boolean
    }

    declare openValue:boolean;
    declare dialogTarget: HTMLDialogElement;

    connect() {
        if (this.openValue) this.open()
        document.addEventListener("turbo:before-cache", () => this.beforeCache())
    }

    disconnect() {
        document.removeEventListener("turbo:before-cache", () => this.beforeCache())
    }

    open() {
        this.dialogTarget.showModal()
    }

    close() {
        debug('starting close animations')
        this.dialogTarget.setAttribute("closing", "")
        Promise.all(
            this.dialogTarget.getAnimations().map((animation) => animation.finished),
        ).then(() => {
            debug('calling close after animations')
            this.dialogTarget.removeAttribute("closing")
            this.dialogTarget.close()
        })
    }

    backdropClose(event) {
        if (event.target.nodeName == "DIALOG") this.close()
    }

    show() {
        this.open()
    }

    hide() {
        this.close()
    }

    beforeCache() {
        debug("beforeCache", this.dialogTarget);
        this.close()
    }
}

export default SlideoverController;
